export const app = `/app`
export const markets = `${app}/markets`
export const deposit = `${app}/deposit`
export const borrow = `${app}/borrow`
export const borrowSent = (txHash: string, loanIdx: string | number) =>
  `${app}/borrow-sent/${txHash}/${loanIdx}`
export const dashboard = `${app}/dashboard`
export const dashboardDeposits = `${app}/dashboard/deposits`
export const dashboardLoans = `${app}/dashboard/loans`
export const dashboardCollateral = `${app}/dashboard/collateral`
export const dashboardOldLoans = `${app}/dashboard/old-loans`
export const analytics = `${app}/analytics`
export const repayment = (loanId: string) => `${app}/repayment/${loanId}`
export const collateral = `${app}/collateral`
export const profile = (address: string) => `/profile/${address}`

export const withdrawalDeposit = (poolAddress: string) =>
  `${app}/withdrawal/deposit/${poolAddress}`
export const transactionList = `${app}/transactions`
